module.exports = __webpack_public_path__ + "static/media/cover_default.6d4113e2.jpg";